/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI76498ResDataItem {
  
  /** 数据类型 */
  typeCode?: string;
  
  /** 数据展示名称 */
  displayName?: string;
  
};
    
  



export type API76498Req = {};



export type API76498Res = IAPI76498ResDataItem[];


// 接口函数 76498 查询模型关联要素

export interface IUseGetAPI76498Return {
  /** 查询模型关联要素: 接口请求状态 */
  isAPI76498Loading: boolean;
  /** 查询模型关联要素: 接口请求返回数据 */
  dataAPI76498: API76498Res;
  /**  查询模型关联要素: 接口数据请求方法 */
  fetchAPI76498Data: ( config?: YWRequestConfig) => Promise<API76498Res>;
  /** 查询模型关联要素: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76498 = ():IUseGetAPI76498Return => {
  let isMount = true;
  const [isAPI76498Loading, setIsAPI76498Loading] = useState(false);
  const [dataAPI76498, setDataAPI76498] = useState<API76498Res>({} as API76498Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/task/model/query/data/type`;

  const fetchAPI76498Data = async ( config?: YWRequestConfig): Promise<API76498Res> => {
  
    if ( isMount ) {
      setIsAPI76498Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API76498Res>(`${basePath}/yoaichat-web/chat/task/model/query/data/type`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI76498(res || {} as API76498Res);
        setIsAPI76498Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76498Loading(false);
      }
      return false as unknown as API76498Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76498Loading,
    dataAPI76498,
    fetchAPI76498Data,
    requestUrl,
  }
}

